import {theme as base} from '@chakra-ui/react'

const fonts = {
  heading: `Inter, ${base.fonts?.heading}`,
  body: `Inter, ${base.fonts?.body}`,
}

export default fonts
